import React, {useEffect, useState} from "react";
import {withStyles} from "@material-ui/core";
import i18n from "../../../i18n";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Divider from "@material-ui/core/Divider";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import MediaDropButton from "../../Media/DropButton";

const FileUploadDialog = (props) => {
    const {
        classes,
        dialog,
        closeDialog,
        uploadConfig,
    } = props;


    const handleSubmit = () => {

        console.log('submit');
    }


    return (
        <Dialog
            open={dialog.open}
            onClose={(e)=> {console.log('is_closing',e.target)}}
            disableBackdropClick={true}
            className={classes.dialog}
            fullWidth={true}
            maxWidth={'sm'}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title" className={classes.dialogTitle}  disableTypography>
                <Typography variant="h6" color={'primary'}>{i18n.get('deficiency.file.upload')}</Typography>
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={() => {
                        //changeDocType(null);
                        //changeFileName('');
                        closeDialog();
                    }}
                >
                    <Icon>close</Icon>
                </IconButton>
            </DialogTitle>
            <Divider/>
            <DialogContent className={classes.dialogContent}>

                {uploadConfig && null && (
                    <React.Fragment>
                        <MediaDropButton
                            uploadConfig={uploadConfig}
                            onNewFile={(file) => {
                                values.files.push(file);
                                //setFieldValue('files', values.files);
                            }}
                        />
                        <Divider className={classes.divider}/>
                    </React.Fragment>
                )}


            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    component={'a'}
                    variant={'contained'}
                    color={'primary'}
                    size={'small'}
                    onClick={handleSubmit}
                >{i18n.get('default.save')}</Button>
            </DialogActions>
        </Dialog>
    );
}

const styles = theme => ({
    dialog: {
        minHeight:700,
    },
    dialogTitle: {
        color: theme.colors.primary,
        "& h6":{
            color: theme.colors.primary,
        },
    },
    dialogContent: {
        overflow:'visible',
    },
    dialogActions: {
        paddingTop: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit * 1.2,
        top: theme.spacing.unit * 2,
    },
    textArea: {
        padding:'0 !important',
        lineHeight: 1.5,
    },
    attributes: {
        opacity:0.6,
        paddingTop: theme.spacing.unit * 2,
    },
});

export default withStyles(styles)(FileUploadDialog);
